<!--短信模板弹窗-->
<template>
  <el-dialog
    title="测试短信记录"
    append-to-body
    :visible.sync="smsDialog"
    width="1050px"
    :before-close="noneBtn"
  >
    <!-- 测试短信记录 -->
    <div>
      <div class="tab-line">
        <div
          class="tab-item"
          :class="{ active: selectIndex == 1 }"
          :style="{
            color: selectIndex == 1 ? globalBG : '',
            'border-top': selectIndex == 1 ? '2px solid ' + globalBG : '',
          }"
          @click="selectIndex = 1"
        >
          测试记录
          <span></span>
        </div>
        <div
          class="tab-item"
          :class="{ active: selectIndex == 2 }"
          :style="{
            color: selectIndex == 2 ? globalBG : '',
            'border-top': selectIndex == 2 ? '2px solid ' + globalBG : '',
          }"
          @click="selectIndex = 2"
        >
          测试记录(官方)
          <span></span>
        </div>
      </div>

      <div class="short-hug">
        <el-table
          v-if="selectIndex == 1"
          v-loading="sysLoading"
          :data="yueList"
          style="width: 100%;border: 1px solid #e6e6e6;"
          height="400"
        >
          <el-table-column
            prop="subTime"
            label="发送时间"
            width="160"
          ></el-table-column>
          <el-table-column prop="mobile" label="测试手机号码">
            <template slot-scope="scope">
              <span class="box" v-if="!scope.row.mobileState">
                  <span
                      class="hover-show"
                      @click="showInfo(type, scope.row, scope.$index)"
                      style="width: 110px"
                      :style="{ background: globalBG }"
                  >
                      显示手机号码
                  </span>
                  <span>{{scope.row.mobile}}</span> 
              </span>
              <span v-else>{{scope.row.mobile}}</span> 
            </template>
          </el-table-column>
          <el-table-column class="special" width="500">
            <template slot="header">
              <span style>测试内容</span>
              <span
                @click="isShowTextAll"
                :style="{ color: changeColor }"
                style="padding-left:10px; cursor: pointer;"
                >{{ isShowAll ? "单行显示" : "展开全部" }}</span
              >
            </template>
            <template slot-scope="scope">{{
              scope.row.content | overFloatContent(isShowAll)
            }}</template>
          </el-table-column>
          <el-table-column label="测试结果">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1" style="color: green"
                >已发送</span
              >
              <span v-if="scope.row.status != 1" style="color: #FE4D45"
                >未发送</span
              >
              <!-- <el-tooltip
                class="item"
                effect="light"
                :content="scope.row.report"
                placement="top-start"
                v-if="scope.row.status !=1"
              >
                <span class="question_icon" style="color: #FE4D45!important;border-color: #FE4D45">?</span>
              </el-tooltip> -->
            </template>
          </el-table-column>
        </el-table>
        <div
          style="text-align: right;margin: 20px 0 10px;"
          v-if="selectIndex == 1"
        >
          <el-pagination
            background
            @size-change="handleSizeYueChange"
            @current-change="handleCurrentYueChange"
            :page-sizes="[10, 20, 30, 40]"
            :total="yueParam.total"
            :page-size="yueParam.size"
            :current-page="yueParam.current"
            layout="total, sizes, prev, pager, next, jumper"
            style="text-align: right; margin-top: 20px;"
          ></el-pagination>
        </div>
        <el-table
          v-if="selectIndex == 2"
          :data="mineTemplateData"
          v-loading="officeLoading"
          style="width: 100%;border: 1px solid #e6e6e6;"
          height="400"
        >
          <el-table-column
            prop="smsTestTime"
            label="发送时间"
            width="160"
          ></el-table-column>
          <el-table-column
            key="smsTestMobile"
            prop="smsTestMobile"
            label="测试手机号码"
          >
          
          </el-table-column>
          <el-table-column class="special" width="500">
            <template slot="#header">
              <span style>测试内容</span>
              <span
                @click="isShowTextAll"
                :style="{ color: changeColor }"
                style="padding-left:10px; cursor: pointer;"
                >{{ isShowAll ? "单行显示" : "展开全部" }}</span
              >
            </template>
            <template slot-scope="scope">{{
              scope.row.smsTestContent | overFloatContent(isShowAll)
            }}</template>
          </el-table-column>
          <el-table-column label="测试结果">
            <template slot-scope="scope">
              <span v-if="scope.row.smsTestResults != 1" style="color: green"
                >已发送</span
              >
              <span v-if="scope.row.smsTestResults == 1" style="color: #FE4D45"
                >未发送</span
              >
              <el-tooltip
                class="item"
                effect="light"
                :content="scope.row.failureResource"
                placement="top-start"
                v-if="scope.row.smsTestResults == 1"
              >
                <span
                  class="question_icon"
                  >?</span
                >
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div
        style="text-align: right;margin: 20px 0 10px;"
        v-if="selectIndex == 2"
      >
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40]"
          :total="templateParam.totalCount"
          :current-page="templateParam.current"
          :page-size="templateParam.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          style="text-align: right; margin-top: 20px;"
        ></el-pagination>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { getPrecisionJdSuffixList } from "@/api/precisionSmstestRecordTableController";
import { getYueTestSms } from "@/api/smsSentRecord";
import { decrypt } from "@/api/sellerController";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  data() {
    return {
      selectIndex: 1,
      isShowAll: true,
      isShowAllText: "展开全部",
      templateBtnType: 1,
      shortUrl: 1,
      titleName: "默认",
      titleIndex: 1,
      officeLoading: false,
      sysLoading: false,

      /* 
       * 我的模板分页数据
       * */
      templateParam: {
        tableCurrentPage: 1,
        pageSize: 10,
        totalCount: 0,
      },

      /*
       * 我的模板数据
       * */
      mineTemplateData: [],
      /*
       * 最近使用数据
       * */
      allShow: false,
      // templateTable: true

      yueList: [],
      yueParam: {
        current: 1,
        size: 10,
        total: 0,
      },
    };
  },
  props: {
    smsDialog: {
      type: Boolean,
      default: false,
    },
  },
  watch: {},
  computed: {
    ...mapState(["modelName"]),
    ...mapState({
      changeColor: "globalBG",
      globalBG: "globalBG",
    }),
  },
  mounted() {
    // console.log(this.apiTypeActive,this.taskTypeActive);
    //er;
    // this.getTemplate();
    this.geTestMsgRecord();
    this.getTextRecordYue();
    // this._queryTemplateTitle();
  },
  filters: {
    //展开收缩
    overFloatContent(d, s) {
      console.log(s);
      try {
        if (!s) {
          return d.length <= 34 ? d : d.substr(0, 34) + "...";
        } else {
          return d;
        }
      } catch (e) {
        return "...";
      }
    },
  },
  methods: {
    showInfo(type, row, index) {
      var param = {
        content: row.encryptMobile,
        
      };
      decrypt(param).then((res) => {
        if (res.code == "1") {
          console.log(res.data);
          this.yueList[index].mobile = res.data
          this.yueList[index].mobileState = true;
        }
      });
    },
    isShowTextAll() {
      this.isShowAll = !this.isShowAll;
    },
    ...mapMutations(["MODELTITLE"]),
    handleSizeChange(val) {
      this.templateParam.pageSize = val;
      this.geTestMsgRecord();
    },
    handleCurrentChange(val) {
      this.templateParam.tableCurrentPage = val;
      this.geTestMsgRecord();
    },
    /*
     * 获取短信记录
     * */
    // getTemplate() {
    //   let title = "";

    //   getPrecisionJdSuffixList({
    //     current: this.templatePaginationInfo.tableCurrentPage, //当前页
    //     size: this.templatePaginationInfo.pageSize, //每页大小
    //     // type: this.taskTypeActive,
    //     //title: title //模板分类
    //   }).then(res => {
    //     // // console.log("%c 系统分组", "color: green", res);
    //     if (res.code === 1) {
    //       let dataList = res.data.records;
    //       for (let i = 0; i < dataList.length; i++) {
    //         if (dataList[i].smsTestContent) {
    //           dataList[i].strLength = dataList[i].smsTestContent.replace(
    //             /&nbsp;/g,
    //             " "
    //           ).length;
    //         }
    //       }
    //       console.log(dataList);
    //       this.mineTemplateData = dataList;
    //       this.templateParam.totalCount = res.data.total;
    //     }
    //   });
    // },

    /** 获取短信记录悦信 */
    getTextRecordYue() {
      var param = {
        current: this.yueParam.current,
        size: this.yueParam.size,
      };
      this.sysLoading = true;
      getYueTestSms(param).then((res) => {
        this.sysLoading = false;
        if (res.code == 1) {
          let dataList = res.data.records;
          for (let i = 0; i < dataList.length; i++) {
            if (dataList[i].content) {
              dataList[i].strLength = dataList[i].content.replace(
                /&nbsp;/g,
                " "
              ).length;
            }
          }
          console.log(dataList);
          this.yueList = dataList;
          this.yueParam.total = res.data.total;
        }
      });
    },

    handleSizeYueChange(val) {
      this.yueParam.size = val;
      this.getTextRecordYue();
    },
    handleCurrentYueChange(val) {
      this.yueParam.current = val;
      this.getTextRecordYue();
    },

    /*
     * 获取短信记录(官方)
     * */
    geTestMsgRecord() {
      let title = "";
      this.officeLoading = true;
      getPrecisionJdSuffixList({
        current: this.templateParam.tableCurrentPage, //当前页
        size: this.templateParam.pageSize, //每页大小
        // title: title //模板分类
      }).then((res) => {
        this.officeLoading = false;
        // console.log("%c 我的模板", "color: green", res);
        if (res.code === 1) {
          let dataList = res.data.records;
          for (let i = 0; i < dataList.length; i++) {
            if (dataList[i].smsTestContent) {
              dataList[i].strLength = dataList[i].smsTestContent.replace(
                /&nbsp;/g,
                " "
              ).length;
            }
          }
          console.log(dataList);
          this.mineTemplateData = dataList;
          this.templateParam.totalCount = res.data.total;
        }
      });
    },

    /*
     * 关闭模板
     * */
    noneBtn() {
      this.$emit("transferName", true);
    },
    sureBtn() {},
    /*
     * 短信是否是全部显示
     * */
    allShowBtnPopup(type) {
      if (type == 1) {
        this.allShow = true;
      } else {
        this.allShow = false;
      }
    },
  },
};
</script>
<!--短信链接弹窗-->
<style lang="scss" scoped>
.box{
  position: relative;
  .hover-show {
      display: none;
      position: absolute !important;
      left: 0%;
      top: 50%;
      text-align: center;
      transform: translate(0, -50%);
      color: #fff !important;
      cursor: pointer;
      padding: 1px 10px;
      border-radius: 4px;
      z-index: 999;
  }
  &:hover {
      .hover-show {
      display: inline-block;
      }
  }
}
.tab-line {
  font-size: 14px;
  color: #666;
  border-bottom: 1px solid #dddddd;
  // margin: 20px 28px 0 28px;
  margin-bottom: 20px;
  .tab-item {
    // padding: 15px 0;
    text-align: center;
    width: 106px;
    height: 36px;
    line-height: 36px;
    display: inline-block;
    position: relative;
    cursor: pointer;
    margin-right: 2px;
    border: 1px solid #dddddd;
    border-bottom: none;
    // &:first-child{
    //   margin-right: 22px;
    // }
    span {
      position: absolute;
      width: 100%;
      left: 50%;
      height: 2px;
      transform: translateX(-50%);
      bottom: -2px;
      display: none;
    }
    &.active {
      border-top: 2px;
      span {
        display: block;
        background: #fff;
      }
    }
  }
}

@mixin translate($number, $number2) {
  -webkit-transform: translateX($number) translateY($number2);
  -moz-transform: translateX($number) translateY($number2);
  -ms-transform: translateX($number) translateY($number2);
  -o-transform: translateX($number) translateY($number2);
  transform: translateX($number) translateY($number2);
}

.popup-text-top {
  height: 52px;
  overflow: hidden;
  background: rgba(244, 245, 249, 1);

  span {
    font-size: 20px;
    font-family: "Microsoft YaHei";
    font-weight: 600;
    line-height: 52px;
    color: rgba(51, 51, 51, 1);
    margin-left: 30px;
  }
}

.short-hug {
  // overflow: hidden;

  .new-button {
    width: 111px;
    height: 30px;
    background: rgba(255, 255, 255, 1);
    /*border:1px solid rgba(32,98,231,1);*/
    border-radius: 3px;
    font-size: 14px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
    /*color:rgba(32,98,231,1);*/
  }

  .short-left {
    width: 98px;
    float: left;
    font-size: 14px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    line-height: 30px;
    color: rgba(51, 51, 51, 1);
    text-align: right;
  }

  .short-item {
    float: left;
    font-size: 14px;
    font-family: "Microsoft YaHei";
    font-weight: 600;
    line-height: 20px;
    color: rgba(153, 153, 153, 1);
    margin-right: 20px;
    cursor: pointer;
    position: relative;
    /*border-bottom: 2px;*/
    /*color:rgba(32,98,231,1);*/
    img {
      position: absolute;
      top: -20px;
      right: -36px;
    }
  }

  .short-item2 {
    margin-top: 20px;
    margin-right: 40px;
  }

  .short-bottom {
    height: 44px;
    /*width:478px;*/
    font-size: 14px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    line-height: 44px;
    position: relative;
    width: 480px;

    .short-bottom-hug {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 44px;
    }

    /*color:rgba(32,98,231,1);*/
    .flex-short {
      float: left;
      /*width: 140px;*/
      margin-left: 22px;
      /*margin-right: 24px;*/
      /*margin-left: 44px;*/
    }

    .short-bgc {
      width: 100%;
      height: 100%;
      opacity: 0.1;
    }
  }
}

.short-last {
  position: absolute;
  bottom: 40px;
  left: 0;
  width: 100%;
  text-align: center;
}

.btn-hug-right {
  text-align: right;
}

.hoveTitle {
  text-align: left;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.table-message {
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
}
    .question_icon {
      width: 14px;
      height: 14px;
      color: #7f85e9 !important;
      display: inline-block;
      line-height: 12px !important;
      text-align: center;
      border-radius: 14px;
      border: 1px solid #7f85e9;
      font-size: 12px !important;
      font-weight: normal !important;
      margin-left: 8px;
      &:hover {
        color: #fe4d45 !important;
        border: 1px solid #fe4d45;
      }
    }
</style>
<style>
.el-textarea__inner {
  border: 1px solid #dcdfe6 !important;
}
.v-modal{
  z-index: 2800 !important;
}
</style>
